import React, { useEffect, useState } from "react";
import api from "~/services/api";
import CreateEditContent from "./CreateEditContent";
import { LandPage, Container, Main } from './styles';
import CustomBodyContent from "./CustomBodyContent";
import { Colors } from "~/config/Colors";
import { SLEditModal } from "~/pages/Sistema/componentes/SistemaList";
import { useSelector } from "react-redux";

export default function GestaoProjetos() {
  const [data, setData] = useState([]);
  const [mountedData, setMountedData] = useState();
  const [loadedData, setLoadedData] = useState(false);
  const { perfil } = useSelector(state => state.auth);

  const [clientes, setClientes] = useState([]);
  const [idCliente, setIdCliente] = useState();
  const [etapas, setEtapas] = useState([]);
  const [idEtapa, setIdEtapa] = useState();

  useEffect(() => {
    api.get('/signed/empresa/gestorprojeto/etapa/etapas', {
      params: { ativo: 1, tipo: 'PRJ', projeto: "S" },
    }).then(r => setEtapas(r?.data));

    api.get("/signed/empresa/gestorprojeto/cliente/clientes", { params: { ativo: 1 } })
      .then(response => setClientes(response.data));
  }, []);

  useEffect(() => {
    setIdEtapa(etapas?.length > 0 ? etapas[0]?.id : 0)
  }, [etapas]);

  useEffect(() => {
    if (idEtapa > 0) {
      api.get('/signed/empresa/gestorprojeto/projetos', {
        params: { ativo: 1, idEtapa, idCliente },
      }).then(r => setData(r?.data));
    }
  }, [idEtapa, idCliente]);

  useEffect(() => {
    setLoadedData(false);
  }, [perfil]);

  return (
    <Main>
      <LandPage>
        <div className="content">
          <Container
            className="container-pj"
            requests={{
              findOne: thisData =>
                api.get('/signed/empresa/gestorprojeto/projeto', {
                  params: { id: thisData.id },
                }),
              deleteOne: thisData =>
                api.delete('/signed/empresa/gestorprojeto/projeto', {
                  data: { id: thisData.id },
                }),
            }}
            manual={true}
          >
            <SLEditModal modalEditManual={mountedData ? true : false} menu={true} title="Atualizar Projeto" setter={setMountedData}>
              {mountedData && (
                <CreateEditContent {...{ mountedData }} />
              )}
            </SLEditModal>

            <CustomBodyContent {...{ data, clientes, etapas, idCliente, setIdCliente, idEtapa, setIdEtapa, setMountedData }} />
          </Container>
        </div>
      </LandPage>
    </Main>
  );
}
